export default 'text';
